<template>
  <PropertyDetailsCard>
    <template #title>
      <span class="title">
        <span>Location</span>
        <Badge v-if="isHiddenOnPlatforms" variant="grey" size="small" label="Hidden on platforms" />
      </span>
    </template>
    <template #action>
      <PropertyDetailsCardEditButton @click="showModal" />
    </template>
    <PropertyLocationInfo :property="property" />
    <PropertyLocationModal ref="locationModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Badge } from '@tallo/design-system';
import { usePropertyStore } from '@tallo/investor/property';
import { PropertyDetailsCard, PropertyDetailsCardEditButton, PropertyLocationInfo } from '@tallo/property';

import PropertyLocationModal from './property-location-modal.vue';

const locationModalRef = ref<InstanceType<typeof PropertyLocationModal>>();
const { property } = usePropertyStore();
const isHiddenOnPlatforms = computed(() => property?.location?.isAddressHidden);

function showModal() {
  locationModalRef.value?.modalRef?.show();
}
</script>

<style scoped lang="scss">
.title {
  display: flex;
  flex-direction: row;
  gap: var(--t-spacing-sm);
}
</style>
